import { React, useState, useEffect } from 'react';
import '../../App.css'
import { Grid, Box, Button, Paper, FormControl, InputLabel, Select, MenuItem, FormHelperText, Typography } from '@mui/material';
import { Addchart } from '@mui/icons-material';
import * as monthList from '../../services/monthList';
import * as yearList from '../../services/yearList';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../Notification';

const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
  </span>
);

const monthOptions = monthList.getMonthList();
const yearOptions = yearList.getYearList();

const today = new Date();
const currentYear = today.getFullYear().toString();
const currentMonthIndex = today.getMonth();
const currentMonthName = monthOptions[currentMonthIndex].title;

const initialFValues = {
  id: 0,
  month: currentMonthName,
  year: currentYear,
  isEsic: true,
}

function ESIStatementReport() {

  const [esiDetail, setEsiDetail] = useState({});
  const [empDetails, setEmpDetails] = useState([]);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/report/esi-report-details`)
      .then((response) => {
        setEsiDetail(response.data[0]);
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          }, 1000);
        }
      });

  }, []);

  const validate = () => {
    let temp = {}
    temp.month = values.month.length != 0 ? "" : "This field is required."
    temp.year = values.year.length != 0 ? "" : "This field is required."

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x == "")
  }

  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);

  function handleInputChange(e) {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    })
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/report/emp-details`, values)
        .then((response => {
          setEmpDetails(response.data);
          navigate('/esi-report', { state: { empDetails: response.data, esiDetail: esiDetail } });
        }))
        .catch((error) => {
        })
    }
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", margin: "10px", padding: "50px", fontWeight: "500px" }}>
      <Paper elevation={5} sx={{ width: "1000px", height: "210px" }}>
        <Grid className="form-title" container spacing={2} justifyContent="center" style={{ marginTop: "15px" }} alignItems="center">
          <Grid item> <Addchart sx={{ width: 45, height: 45 }} /> </Grid>
          <Grid item> <Typography variant="h5">ESI Statement Report</Typography> </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>

          <Box sx={{ margin: "30px" }}>
            {/* All elements in one line */}
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              flexWrap: 'wrap'
            }}>

              {/* Month field */}
              <FormControl
                variant="outlined"
                sx={{ width: '200px' }}
                {...(errors.month && { error: true })}
              >
                <InputLabel><RequiredLabel label="Month" /></InputLabel>
                <Select
                  label="Month"
                  name="month"
                  size="small"
                  value={values.month}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">None</MenuItem>
                  {
                    monthOptions.map(
                      item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                    )
                  }
                </Select>
                {errors.month && <FormHelperText>{errors.month}</FormHelperText>}
              </FormControl>

              {/* Year field */}
              <FormControl
                variant="outlined"
                sx={{ width: '200px' }}
                {...(errors.year && { error: true })}
              >
                <InputLabel><RequiredLabel label="Year" /></InputLabel>
                <Select
                  label="Year"
                  name="year"
                  size="small"
                  value={values.year}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">None</MenuItem>
                  {
                    yearOptions.map(
                      item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                    )
                  }
                </Select>
                {errors.year && <FormHelperText>{errors.year}</FormHelperText>}
              </FormControl>

              {/* Display button */}
              <Button
                color="success"
                variant="contained"
                onClick={handleSubmit}
                sx={{ height: 40 }}
              >
                Display
              </Button>
            </Box>
          </Box>
        </form>
      </Paper>
      <Notification
        notify={notify}
        setNotify={setNotify}
      />
    </Box>
  )
}

export default ESIStatementReport;